<div [class]="status()">
    <app-icon [svgIcon]="statusToIcon(status())"></app-icon>
</div>

